import React, { useMemo } from 'react';
import { Plus } from 'lucide-react';
import { useProjectTransactions } from '../../hooks/useProjectTransactions';
import Modal from "@/components/ui/Modal";
import DataTable from "@/components/ui/DataTable";
import Button from "@/components/ui/Button";
import { Select } from "@/components/ui/FormComponents";
import { TRANSACTION_HISTORY_COLUMNS } from '../../constants/transactionHistoryColumns';
import { inr } from '../../utils/projectFormatters';

export const ProjectTransactionHistoryModal = ({ isOpen, onClose, project, onRecordPayment, refreshTrigger }) => {
  const {
    loading,
    summary,
    filteredTxs,
    recipientOptions,
    recipientFilter,
    setRecipientFilter
  } = useProjectTransactions(project?._id, isOpen, refreshTrigger);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`Transaction History: ${project?.projectName || project?.customerName}`}
      size="2xl"
    >
      <div className="flex flex-col gap-6 -mx-4 -mt-4">
        {/* Stats Row */}
        <div className="p-6 bg-slate-50/50 flex flex-wrap items-center gap-4 border-b border-slate-100">
          <div className="flex-1 min-w-[150px] bg-white p-4 rounded-xl border border-slate-200 shadow-sm">
            <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest block mb-1">Contract Value</span>
            <span className="text-[20px] font-black text-slate-800">{inr(summary?.contractValue || project?.contractValue)}</span>
          </div>
          <div className="flex-1 min-w-[150px] bg-emerald-50/50 p-4 rounded-xl border border-emerald-100 shadow-sm">
            <span className="text-[10px] font-black text-emerald-600 uppercase tracking-widest block mb-1">Received</span>
            <span className="text-[20px] font-black text-emerald-700">{inr(summary?.totalPaid)}</span>
          </div>
          <div className="flex-1 min-w-[150px] bg-rose-50/50 p-4 rounded-xl border border-rose-100 shadow-sm">
            <span className="text-[10px] font-black text-rose-600 uppercase tracking-widest block mb-1">Outstanding</span>
            <span className="text-[20px] font-black text-rose-700">{inr(summary?.netBalance)}</span>
          </div>

          <Button
            onClick={() => onRecordPayment?.(project)}
            leftIcon={<Plus size={16} />}
            variant="primary"
            className="h-[34px] shadow-md"
          >
            <span className="uppercase tracking-widest text-[11px]">Record Payment</span>
          </Button>
        </div>

        {/* Table Content */}
        <div className="min-w-0 flex flex-col gap-4">
          <div className="px-6 flex items-center justify-between">
            <h3 className="text-[14px] font-bold text-slate-800 flex items-center gap-2">
              Recent Transactions
              <span className="px-2 py-0.5 rounded-full bg-slate-100 text-slate-500 text-[10px]">{filteredTxs.length}</span>
            </h3>

            {/* <div className="flex items-center gap-2">
              <div className="w-[200px]">
                <Select
                  value={recipientFilter}
                  onChange={(e) => setRecipientFilter(e.target.value)}
                  className="px-3 h-10 text-[11px]"
                >
                  <option value="all">All recipients</option>
                  {recipientOptions.map(r => (
                    <option key={r} value={r}>{r}</option>
                  ))}
                </Select>
              </div>
            </div> */}
          </div>

          <DataTable
            columns={TRANSACTION_HISTORY_COLUMNS}
            data={filteredTxs}
            isLoading={loading}
            tableClassName="min-w-[1300px]"
            emptyState={
              <div className="py-20 text-center text-slate-400 font-bold italic text-[13px]">
                {recipientFilter === 'all'
                  ? "No transactions found for this project."
                  : `No transactions found for recipient "${recipientFilter}".`}
              </div>
            }
          />
        </div>
      </div>
    </Modal>
  );
};
